


















































































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";
import Add from "./add.vue";
import Edit from "./edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  isCopy = false;

  dispatchType = "wechatnotify/list";

  dispatchTypeDelete = "wechatnotify/delete";

  deleteConfirmContent = "确认要删除该配置吗？";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "类型", scopedSlots: { customRender: "type" } },
    { title: "用户id", dataIndex: "user_id" },
    { title: "用户", dataIndex: "username" },
    { title: "公众号openid", dataIndex: "openid" },
    { title: "unionid", dataIndex: "unionid" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadAuthUserGroups();
    this.loadData();
  }

  showCopyModal(id: number) {
    this.editId = id;
    this.isCopy = true;
    this.editModalVisible = true;
  }
}
